// With native logging enabled (every debuggable build, since capacitor.config
// sets no loggingBehavior) Capacitor's bridge runs console.dir() on each plugin
// call and result. Chromium keeps the arguments of the last ~1000 console
// messages alive, so every Preferences.set of a large payload stayed on the JS
// heap long after the write. This flag is read per call, so switching it off
// before the stores issue their first Preferences calls is enough. logcat's
// Capacitor/Console forwarding is gated on the Java side and keeps working.
if (window.Capacitor) {
	window.Capacitor.isLoggingEnabled = false;
}
